import {createApp} from 'vue'
import FileListCard from './FileListCard'

const el = '.kb-component--file-list-card'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((FileListCardDOM)=>{
            const cardData = FileListCardDOM.dataset.card 
            ? JSON.parse(FileListCardDOM.dataset.card) 
            : null
            const cardButtonIcons = FileListCardDOM.dataset.cardButtonIcons
            ? JSON.parse(FileListCardDOM.dataset.cardButtonIcons)
            : {}
            const component = createApp(FileListCard, {cardData, cardButtonIcons}).use(Store)
            component.mount(FileListCardDOM)
        })
    }
}